/* Naguirre — ajustes da gaveta do carrinho (03/10/2026).
   1) O "Voltar" do celular/navegador fecha a gaveta em vez de tirar a cliente da página.
      Medido em 02/10: abrir a gaveta não criava entrada no histórico, então o Voltar do
      Android (e a seta do navegador do Instagram) levava a cliente para fora do produto.
   2) No app de cupom, o nome interno de promoção automática (ex.: "blusas-promo") vira
      "Promoção aplicada". Cupom digitado (ex.: BELA5, das consultoras) mantém o nome. */
(function () {
  'use strict';

  var body = document.body;
  if (!body) return;

  // ---------- 1) Voltar fecha a gaveta ----------
  var CLASSE_ABERTA = 'cart-sidebar-show';
  var CHAVE = 'ngGaveta';
  var empurrou = false;
  var hrefDoPush = null;

  function aberta() {
    return body.classList.contains(CLASSE_ABERTA);
  }

  function nossaEntrada() {
    return !!(history.state && typeof history.state === 'object' && history.state[CHAVE]);
  }

  function fecharGaveta() {
    // Fecha tirando a classe, exatamente como o handler do X do tema faz. NÃO usar
    // botao.click(): clique sintético vira "clique" para os rastreadores (o automático
    // da Meta registrou SubscribedButtonClick nesse caso no teste de 03/10).
    body.classList.remove(CLASSE_ABERTA);
  }

  if (window.history && typeof history.pushState === 'function') {
    // Entrada órfã: a página recarregou (ou voltou do checkout) já em cima da entrada que a
    // gaveta criou, com a gaveta fechada. Sem isto, o 1º Voltar da cliente "não faz nada".
    if (nossaEntrada() && !aberta()) {
      try { history.back(); } catch (e) {}
    }

    new MutationObserver(function () {
      if (aberta() && !empurrou) {
        // Preserva o estado que já existia (ex.: filtros da coleção leem state.searchParams).
        var base = (history.state && typeof history.state === 'object') ? history.state : {};
        var estado = {};
        for (var k in base) {
          if (Object.prototype.hasOwnProperty.call(base, k)) estado[k] = base[k];
        }
        if (!('searchParams' in estado)) estado.searchParams = location.search.slice(1);
        estado[CHAVE] = true;
        try {
          history.pushState(estado, '');
          empurrou = true;
          hrefDoPush = location.href;
        } catch (e) {}
      } else if (!aberta() && empurrou) {
        // Fechou pelo X, pelo fundo ou pelo "Continuar": tira a entrada que criamos, mas só se a
        // URL ainda for a do push. Se algo trocou a URL com a gaveta aberta (ex.: ?variant=), voltar
        // mudaria a URL e a Meta e o GA4 contariam uma página a mais.
        empurrou = false;
        if (location.href === hrefDoPush) {
          try { history.back(); } catch (e) {}
        }
      }
    }).observe(body, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('popstate', function () {
      // Fecha só quando o Voltar saiu da nossa entrada (e não num popstate qualquer).
      if (empurrou && aberta() && !nossaEntrada()) {
        empurrou = false;
        fecharGaveta();
      }
    });
  }

  // ---------- 2) Promoção automática sem nome interno no app de cupom ----------
  // O app mostra cada desconto do carrinho como um "chip" (.code-name, com title = nome).
  // Na promoção automática ("leve 3" etc.) a Shopify devolve o tipo VAZIO no /cart.js, então
  // a regra é: o que NÃO está entre os cupons digitados (cart.discount_codes) vira
  // "Promoção aplicada". A lista de cupons fica em cache e só é buscada de novo quando
  // aparece um chip novo ou quando o tema avisa que o carrinho mudou (evento cart-update).
  var ROTULO = 'Promoção aplicada';
  var cuponsEmCache = null;
  var assinaturaDoCache = '';
  var buscando = false;
  var sujo = false;

  function chips() {
    return Array.prototype.slice.call(document.querySelectorAll('#scDiscountApp .code-name'));
  }

  function nomeOriginal(no) {
    return no.getAttribute('data-ng-nome') || no.getAttribute('title') || '';
  }

  function assinatura(lista) {
    return lista.map(function (no) { return nomeOriginal(no).toLowerCase(); }).sort().join('|');
  }

  function textoDoNome(no) {
    for (var k = 0; k < no.childNodes.length; k++) {
      var filho = no.childNodes[k];
      if (filho.nodeType === 3 && filho.nodeValue.trim()) return filho;
    }
    return null;
  }

  function aplicar(cupons) {
    chips().forEach(function (no) {
      var original = nomeOriginal(no);
      if (!original) return;
      var texto = textoDoNome(no);
      var ehCupomDigitado = cupons.indexOf(original.toLowerCase()) !== -1;
      if (!ehCupomDigitado) {
        if (!no.hasAttribute('data-ng-nome')) no.setAttribute('data-ng-nome', original);
        if (texto && !no.hasAttribute('data-ng-texto')) no.setAttribute('data-ng-texto', texto.nodeValue);
        no.setAttribute('title', ROTULO);
        if (texto && texto.nodeValue !== ROTULO) texto.nodeValue = ROTULO;
      } else if (no.hasAttribute('data-ng-nome')) {
        // Passou a ser cupom digitado: devolve o nome original.
        no.setAttribute('title', no.getAttribute('data-ng-nome'));
        if (texto && no.hasAttribute('data-ng-texto')) texto.nodeValue = no.getAttribute('data-ng-texto');
        no.removeAttribute('data-ng-nome');
        no.removeAttribute('data-ng-texto');
      }
    });
  }

  function renomearPromocoes() {
    var lista = chips();
    if (!lista.length) return;
    var ass = assinatura(lista);
    if (cuponsEmCache && ass === assinaturaDoCache) {
      aplicar(cuponsEmCache);
      return;
    }
    if (buscando) {
      sujo = true;
      return;
    }
    if (!window.fetch) return;
    buscando = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        cuponsEmCache = (carrinho.discount_codes || []).map(function (d) { return String(d.code || '').toLowerCase(); });
        assinaturaDoCache = ass;
        buscando = false;
        aplicar(cuponsEmCache);
        if (sujo) {
          sujo = false;
          agendar();
        }
      })
      .catch(function () { buscando = false; });
  }

  var agendado = false;
  function agendar() {
    if (agendado) return;
    agendado = true;
    window.requestAnimationFrame(function () {
      agendado = false;
      renomearPromocoes();
    });
  }

  document.addEventListener('cart-update', function () {
    cuponsEmCache = null;
    agendar();
  });

  var gaveta = document.getElementById('halo-cart-sidebar');
  if (gaveta) {
    new MutationObserver(agendar).observe(gaveta, { childList: true, subtree: true });
  }
  if (body.classList.contains('template-cart')) {
    var areaCarrinho = document.querySelector('#MainContent') || document.querySelector('main');
    if (areaCarrinho) new MutationObserver(agendar).observe(areaCarrinho, { childList: true, subtree: true });
  }
  agendar();
})();
